// extracted by mini-css-extract-plugin
module.exports = {"root":"Text_root__2o39k","normal":"Text_normal___fDGc","bold":"Text_bold__Nu95Y","noMargin":"Text_noMargin__eKTjZ","responsive":"Text_responsive__EdyT4"};